exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.restart-quiz-button[data-v-2cf81da0] {\n  position: absolute;\n  top: calc(50% - 11px);\n  height: 22px;\n  right: 16px;\n}", ""]);

// exports
